import { connect } from 'react-redux'
import BreadcrumbComponent from './component'

const mapStateToProps = state => ({
    payload: state.pages.akten.common.breadcrumbsData,
})

const mapDispatchToProps = dispatch => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BreadcrumbComponent)